export default __webpack_public_path__ + "static/media/instagram.717ff800.svg";